import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import SunEditor from 'suneditor-react';
import { Query, withApollo, Mutation } from "react-apollo";
import { Formik } from 'formik';
import { Button, Row, Col, Form, Accordion, Card } from 'react-bootstrap';
import { sessaoOneQuery } from '../../../graphql/Sessao';
import { usuarioOneQuery, papelListQuery, layoutParticipanteOptionsQuery, usuarioAutoCompleteQuery, grupoAutoCompleteQuery,novaSessaoSave } from '../../../graphql/Outros';
import Select from 'react-select';
import { connect } from "react-redux";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import 'date-fns';
import moment from 'moment-timezone';
import 'suneditor/dist/css/suneditor.min.css';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import pt_BR from '../../_componentes//suneditor-translate/pt-BR';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import OfflineBoltOutlinedIcon from '@material-ui/icons/OfflineBoltOutlined';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import brLocale from "date-fns/locale/pt-BR";
import Environment from "../../../environment/environment";
import Swal from 'sweetalert2';
import { withRouter } from "react-router-dom";
import OrdenaConvidados from '../ordena-convidados';
const { PUBLIC_URL } = process.env;

const AsyncTypeahead = asyncContainer(Typeahead);

const { Control, Label } = Form;
const ID_ORGANIZADOR = 3;
const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    unselectable: {
        paddingTop: '12px',
        "-moz-user-select": "none",
        "-webkit-user-select": "none",
        "-ms-user-select": "none"
    },
    quote: {
        backgroundColor: '#DEDEDE',
        paddingLeft: 10,
        paddingRight: 10,
        "-moz-user-select": "all",
        "-webkit-user-select": "all",
        "-ms-user-select": "all"
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    datetimeFieldsMargin: {
        '& div': {
            marginTop: '-2px !important',
            marginBottom: '10px !important',
        }
    },
    checkBoxLike: {
        color: '#444 !important',
        marginTop: '2px',
        marginBottom: '2px'
    },
    convidadosList: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    convidadoRow: {
        marginBottom: '5px'
    },
    addConvidadoRow: {
        marginTop: '20px',
        marginBottom: '10px'
    },
    buttonAddConvidado: {
        marginTop: '3px',
        width: '100%'
    },
    conviteEditorFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '25px'
    },
    grupoRow: {
        marginBottom: '5px'
    },
    addGrupoRow: {
        marginTop: '20px',
        marginBottom: '10px'
    },
    gruposList: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    buttonAddGrupo: {
        marginTop: '3px',
        width: '100%'
    },
    saveButton: {
        marginTop: '30px'
    },
    layoutParticipanteRow: {
        marginTop: '10px',
        marginBottom: '15px',
    },
    participantePodeEnviarChatRow: {
        marginTop: '18px',
        marginBottom: '15px',
    },
    participantePodeEnviarChatLabel: {
        paddingTop: '11px',
    },
    participantePodeEnviarChatCheckbox: {
        marginLeft: '-10px',
    },
    rowMaxParticipantes: {
        marginBottom: '10px'
    },
    qtdParticipantes: {
        width: '70px',
    },
    sublabel: {
        fontStyle: "italic",
        fontSize: '10px'
    },
    grupoAccordion: {
        marginTop: '30px'
    },
    accordionButton: {
        '&:focus': {
            backgroundColor: '#f7f8fa !important',
            color: '#5867dd !important',
            textDecoration: 'none !important',
        },
        '&:hover': {
            backgroundColor: '#5d78ff !important',
            color: '#ffffff !important',
            textDecoration: 'none !important'
        }
    },
    checkboxLabel: {
        '&:hover': {
            cursor: 'pointer',
        }
    },
    rowAcessoViaLinkCampos: {
        paddingTop: '5px',
        paddingBottom: '10px',
    }
});

const selectStyle = {
  control: (base, state) => ({
    ...base,
    border: '1px solid #c0c0c0',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #c0c0c0',
    }
  })
};

const propTypes = {
  id: PropTypes.number,
};

const defaultProps = {
  id: -1,
};

class SessaoForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      _v: 1,
      isLoadingUser: false,
      isLoadingGrupo: false,
      usuarioSelecionado: null,
      templateText: ''
    }

    this.deduplicaConvidados = this.deduplicaConvidados.bind(this);
    this.handleFormikSubmit = this.handleFormikSubmit.bind(this);
    this.renderConvidados = this.renderConvidados.bind(this);

  }

  notifyChange() {
    this.setState({ _v: this.state._v + 1 });
  }

    componentDidMount() {
        const { userId } = this.props;
        let enumsQueries = [
            this.props.client.query({
                query: papelListQuery,
                variables: {
                    archived: false,
                },
                fetchPolicy: "network-only"
            }),
            this.props.client.query({
                query: usuarioOneQuery,
                variables: {
                    id: userId,
                },
                fetchPolicy: "network-only"
            }),
            this.props.client.query({
                query: layoutParticipanteOptionsQuery,
                variables: {},
                fetchPolicy: "network-only"
            }),
        ];
        Promise.all(enumsQueries).then((data) => { 
            let enums = Object.assign({}, ...data.map(e => e.data));
            return this.setState({ enumsLoaded: true, enums}) ;
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { templateText, templateDataInicio, templateDataFim, templateNome } = this.state;
        if (templateText) {
            let novoTemplateText = templateText.replace( prevState.templateNome, templateNome );
            novoTemplateText = novoTemplateText.replace( 'Início:&nbsp;<strong>'+prevState.templateDataInicio, 'Início:&nbsp;<strong>'+templateDataInicio );
            novoTemplateText = novoTemplateText.replace( 'Fim:&nbsp;<strong>'+prevState.templateDataFim, 'Fim:&nbsp;<strong>'+templateDataFim );
            
            if (this.state.templateText != novoTemplateText) {
                this.setEditorContent(novoTemplateText);
            }
        }
    }

    setEditorContent(content) {
        this.setFieldValue('texto_convite', content);

        this.setState({
            templateText: null
        });

        setTimeout( () => {
            this.setState({
                templateText: content
            });
        }, 10);
    }

    renderTop() {
        const { handleModalClose, classes } = this.props;
        if (!handleModalClose) return null;
        return (
            <Row>
                <Col md={{span: 10, offset: 1}} className={classes.headerWrapper}>
                    <h3>Editar</h3>
                    <Button onClick={() => handleModalClose()}  variant="secondary" className="btn-close btn-secondary-get">Fechar</Button>
                </Col>
            </Row>
        );
    }

    renderDatePickers(type, values, label, setFieldValue) {
        const { classes } = this.props;
        const today = moment();
        return (
            <Row>
                <Col xs="7" md="7" lg="3"><Label>{label}</Label></Col>
                <Col xs="7" md="7" lg="3" className={classes.datetimeFieldsMargin}>
                    <MuiPickersUtilsProvider locale={brLocale} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            margin = "normal"
                            id = "data"
                            labelFunc = {dt => Environment.momentToLocalDateString(dt)}
                            value = {this.state[type + "_date"] || values[type]}
                            onChange = {(date, formattedDate) => {
                                if (!date || isNaN(date.getTime())) {
                                    this.setState( { [type + "_date"] : date } );
                                    return;
                                }

                                const types=[];
                                types.push(type);

                                if (type == 'inicio') {
                                    // Foi solicitado que ao modificar a data de inicio, a de fim seja alterada também
                                    types.push('fim');
                                }

                                types.forEach(type => {
                                    //Quando modifica a data, apenas pega o componente data do objeto recebido
                                    const datePart = formattedDate;
                                    const timePart = Environment.momentToLocalTimeString(values[type]);
                                    const newDateTime = Environment.localDateAndTimeStringToMoment(datePart + " " + timePart);

                                    if (type == 'inicio') {
                                        this.setState({
                                            templateDataInicio: Environment.momentToLocalDateAndTimeString(newDateTime)
                                        });
                                    }

                                    if (type == 'fim') {
                                        this.setState({
                                            templateDataFim: Environment.momentToLocalDateAndTimeString(newDateTime)
                                        });
                                    }


                                    setFieldValue(type, newDateTime);
                                    this.setState( { [type + "_date"] : date } );
                                });

                                this.notifyChange();
                            }}
                            format = "dd/MM/yyyy"
                            minDate = {type == 'inicio' ? today : values['inicio']}
                            invalidDateMessage = "Data inválida."
                            minDateMessage = {type == 'inicio' ? "Data inicial não pode ser menor que agora" : "Data final não pode ser maior que inicial."}
                            KeyboardButtonProps = {{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Col>

                <Col xs="5" md="5" lg="2" className={classes.datetimeFieldsMargin}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                            margin="normal"
                            id="time"
                            ampm={false}
                            invalidDateMessage="Hora inválida."
                            labelFunc={dt => Environment.momentToLocalTimeString(dt)}
                            value={this.state[type + "_time"] || values[type]}
                            onChange={(date, formattedTime) => {
                                if(!date || isNaN(date.getTime())) {
                                    this.setState( { [type + "_time"] : date } );
                                    return;
                                }

                                //Quando modifica a hora, apenas pega o componente hora do objeto recebido
                                const datePart = Environment.momentToLocalDateString(values[type]);
                                const timePart = formattedTime + ":" + (type=='fim'?'59':'00');
                                const newDateTime = Environment.localDateAndTimeStringToMoment(datePart + " " + timePart);

                                if (type == 'inicio') {
                                    this.setState({
                                        templateDataInicio: Environment.momentToLocalDateAndTimeString(newDateTime)
                                    });
                                }

                                if (type == 'fim') {
                                    this.setState({
                                        templateDataFim: Environment.momentToLocalDateAndTimeString(newDateTime)
                                    });
                                }

                                setFieldValue(type, newDateTime);
                                this.setState( { [type + "_time"] : newDateTime } );
                                this.notifyChange();
                            }}
                            KeyboardButtonProps={{
                                'aria-label': 'change time',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Col>
            </Row>
        )
    }

    restauraConvitePadrao(values) {
        const { nome } = values;
        const nomeSessao = nome ? nome : '{{NOME-SESSAO}}';
        const htmlTemplate = `
            <div>
                <div class="inserted">
                    <div><br></div>
                    <div>Nome:&nbsp;<strong> ${nomeSessao} </strong></div>
                    <div>
                        <div>
                            <div>Início:&nbsp;<strong>${ Environment.momentToLocalDateAndTimeString(values.inicio) }</strong></div>
                        </div>
                    </div>
                    <div>Fim:&nbsp;<strong>${ Environment.momentToLocalDateAndTimeString(values.fim) }</strong><br></div>
                    <div><strong><br></strong></div>
                    <div>
                        <div>
                            <div>Link de acesso: {{LINK}}</div>
                        </div>
                    </div>
                </div>
            </div>`;

        this.setEditorContent(htmlTemplate);
    }

    deduplicaConvidados (listaConvidados) {
        const dedupLookup = {};
        const novaListaConvidados = listaConvidados.filter( convidado => {
            const usuarioId = convidado.usuario ? convidado.usuario.id : null;
            const grupoId = convidado.grupo ? convidado.grupo.id : null;
            const papelId = convidado.papel ? convidado.papel.id : null;
            const key = usuarioId + '_' + grupoId + '_' + papelId;

            if(dedupLookup[ key ]) {
                return false;
            }

            dedupLookup[ key ] = 1;

            return true;
        });
        return OrdenaConvidados(novaListaConvidados);
    }

    renderForm() {
        const { id, classes, userId, handleModalClose } = this.props;
        const { enums, enumsLoaded, templateText } = this.state;

        return (
            <Query query={sessaoOneQuery} skip={!id} variables={{ id }} fetchPolicy='network-only'>
            {({ data, loading, error, refetch }) => {
                    if (loading || !enumsLoaded) return 'Carregando ...';
                    if (error) return `Error! ${error.message}`;

                    let dataSessao = {};

                    if (data.sessaoOne) {
                        dataSessao = {
                            ...data.sessaoOne,
                            inicio: moment(data.sessaoOne.inicio),
                            fim: moment(data.sessaoOne.fim)
                        };
                    } else {
                        dataSessao = {
                            inicio: moment().add(30, 'minutes'),
                            fim: moment().add(2.5, 'hours')
                        }
                    }

                    const { templateDataInicio } = this.state
                    if (!templateDataInicio) {
                        setTimeout ( () => 
                            this.setState({
                                templateDataInicio: Environment.momentToLocalDateAndTimeString(dataSessao.inicio),
                                templateDataFim: Environment.momentToLocalDateAndTimeString(dataSessao.fim),
                                templateNome: '{{NOME-SESSAO}}'
                            })
                        , 0);
                        return null;
                    }

                    if(dataSessao.convidados) {
                        OrdenaConvidados(dataSessao.convidados);
                    }

            return  (
                <Formik
                    initialValues = {{
                        id: id || -1,
                        convidados:  [{
                            id: enums.usuarioOne.id,
                            grupo: null,
                            usuario: {
                                id: enums.usuarioOne.id,
                                nome: enums.usuarioOne.nome,
                            },
                            papel: enums.papelList.filter(i => i.id === ID_ORGANIZADOR).shift(),
                        }],
                        gravar: true,
                        permite_acesso_via_link: true,
                        acesso_via_link_requer_email: this.props.branding.acesso_via_link_requer_email_padrao,
                        acesso_via_link_maximo_visitantes: 20,
                        ...dataSessao,
                    }}
                    onSubmit = {this.handleFormikSubmit}
                >
                {(props) => {
                    const { handleChange, handleSubmit, values, setFieldValue } = props;

                    this.setFieldValue = setFieldValue;

                    if(!this.initialized) {
                        setTimeout(() => {
                            this.restauraConvitePadrao(values);
                        }, 250);
                        
                        this.initialized = true;
                    }

                    const nomeBlurHandle = (evt) => {
                        const valor = evt.target.value || '{{NOME-SESSAO}}';
                        this.setState({
                            templateNome: valor
                        });
                    }

                    const permiteAcessoViaLinkChangeHandle = evt => {
                        setFieldValue('permite_acesso_via_link', !values.permite_acesso_via_link);
                        if (!evt.target.checked) {
                            setFieldValue('acesso_via_link_requer_email', false);
                            setFieldValue('acesso_via_link_requer_instituicao', false);
                            setFieldValue('acesso_via_link_requer_cargo', false);
                        } else {
                            setFieldValue('acesso_via_link_requer_email', true);
                        }
                    }

                    return (
                        <Form onSubmit={handleSubmit}>
                            <Row style={{maxWidth: 1300, margin: 'auto'}}>
                                <Col md={{span: 10, offset: 1}}>

                                    {this.renderDatePickers('inicio', values, 'Início previsto:', setFieldValue)}
                                    {this.renderDatePickers('fim', values, 'Término previsto:', setFieldValue)}
                                    
                                    <Row>
                                        <Col md="3"><Label htmlFor={"nome"} style={{paddingTop: '7px'}}>Nome:</Label></Col>
                                        <Col md="9">
                                            <Control id="nome" onChange={handleChange} onBlur={nomeBlurHandle} type="text" value={values.nome || ""}></Control>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="3"><Label htmlFor={"gravar"} style={{paddingTop: '9px'}}>Permitir gravação:</Label></Col>
                                        <Col md="3">
                                            <Checkbox
                                                id="gravar"
                                                onChange={handleChange}
                                                checked={values.gravar || false}
                                                value={values.gravar}
                                                className={classes.checkBoxLike}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="3"><Label htmlFor={"permite_acesso_via_link"} style={{paddingTop: '9px'}}>Permitir acesso via link: <br/> <i>(visitantes)</i></Label></Col>
                                        <Col md="3">
                                            <Checkbox
                                                id="permite_acesso_via_link"
                                                onChange={permiteAcessoViaLinkChangeHandle}
                                                checked={values.permite_acesso_via_link || false}
                                                value={values.permite_acesso_via_link}
                                                className={classes.checkBoxLike}
                                            />

                                            <Label className={classes.sublabel}>(máximo {values.acesso_via_link_maximo_visitantes})</Label>
                                        </Col>
                                    </Row>

                                    <Row style={{marginTop: '5px'}}>
                                        <Col md="3"><Label>Texto do e-mail de convite:</Label></Col>
                                        <Col sm="12">
                                                { !templateText ? (
                                                        <div style={{height: 200}}></div>
                                                    ) : (
                                                        <SunEditor
                                                            lang={pt_BR}
                                                            setOptions={{
                                                                buttonList: [
                                                                    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                                                                    ["fontSize", "removeFormat", "fontColor"],
                                                                    ["outdent", "indent"],
                                                                    ["align", "list"],
                                                                    ["fullScreen", "codeView"],
                                                                ]
                                                            }}
                                                            setContents={values.texto_convite}
                                                            onChange={(data) => {
                                                                this.setState({
                                                                    templateText: data
                                                                });
                                                                setFieldValue('texto_convite', data);
                                                                this.notifyChange();
                                                            }}
                                                        />
                                                    )
                                            }
                                            <div className={classes.conviteEditorFooter}>
                                                <span className={classes.unselectable}>Para inserir um link de acesso, use o substituível <span className={classes.quote}>{"{{LINK}}"}</span></span>
                                                <Tooltip title="Restaurar padrão" placement="top">
                                                    <IconButton
                                                        onClick={() => {
                                                            this.restauraConvitePadrao(values);
                                                        }}
                                                    >
                                                        <OfflineBoltOutlinedIcon fontSize="large" />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </Col>
                                    </Row>

                                    {this.renderConvidados(props)}
                                    {this.renderSessaoAvançada(props)}

                                    <Row>
                                        <Col lg="3" className={classes.saveButton}>
                                            <Button type="submit" variant="primary" className="btn-primary-get">Salvar</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    );
                  }
                }
              </Formik>
            );
          }
        }
      </Query>
    );
  }

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                {this.renderTop()}
                {this.renderForm()}
            </Fragment>
        )
    }

    renderConvidados(formikProps) {

        const { values, setFieldValue } = formikProps;
        const { enums } = this.state;
        const { classes } = this.props;

        return (
            <Fragment>
                <Row>
                    <Col md="3">
                        <Label>Convidados:</Label>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{span: 9, offset: 3}}>
                        {values.convidados.filter( u => u.usuario != null).map((i) => {
                            return (
                                <Fragment key = {i.usuario.id + ' +' + i.papel.nome}>
                                    <Row className={classes.convidadoRow}>
                                        <Col xs="2" lg="1">
                                            <IconButton
                                                disabled={ i.usuario.id !== enums.usuarioOne.id ? false : true }
                                                onClick = {() => {
                                                    setFieldValue('convidados', this.deduplicaConvidados(values.convidados.filter( item  => {
                                                        //Se não for de usuário, mantém na lista (este botão é apenas para usuário)
                                                        if( item.usuario == null )
                                                        return true;

                                                        //Se for o item clicado, remove da lista
                                                        if(item.usuario.id === i.usuario.id && item.papel.id === i.papel.id)
                                                        return false;

                                                        return true;
                                                    })));
                                                    this._convidadosAsyncTypeahead._instance.focus();
                                                    this.notifyChange();
                                                }}>
                                                <HighlightOffOutlinedIcon />
                                            </IconButton>
                                        </Col>

                                        <Col xs="9" lg="6" className={classes.convidadosList}>
                                            <Label>{i.usuario.nome} </Label>
                                        </Col>
                                        
                                        <Col sm="12" lg="5">
                                            <Select
                                                className = {"gn-select"}
                                                placeholder = {"Execução"}
                                                options = {enums.papelList}
                                                defaultValue = {i.papel}
                                                getOptionValue = {el => {
                                                    return el.id
                                                }}
                                                getOptionLabel = {el => el.nome}
                                                onChange = {(selectedItem) => {
                                                    setFieldValue('convidados', this.deduplicaConvidados([
                                                        ...values.convidados.filter(u => u.grupo || ( u.usuario.id + "_" + u.papel.id !== i.usuario.id + "_" + i.papel.id ) ),
                                                        { 
                                                        usuario: {
                                                            ...i.usuario
                                                        },
                                                        grupo: null,
                                                        papel: selectedItem,
                                                        },
                                                    ]));
                                                    this.notifyChange();
                                                }}
                                                isDisabled = {i.usuario.id === enums.usuarioOne.id}
                                                styles = {selectStyle}
                                            />
                                        </Col>
                                    </Row>
                                </Fragment>
                            );
                        })}

                        <Row className={classes.addConvidadoRow}>
                            <Col xs="12" lg={{span: 6, offset: 1}}>
                                <AsyncTypeahead
                                    id = {'search-convidados'}
                                    isLoading = {this.state.isLoadingUser}
                                    labelKey = "display_name"
                                    onSearch = { query => {
                                        this.setState({
                                            queryString: query
                                        });
                                        if (query.length < 4) return;
                                        this.setState({ isLoadingUser: true });
                                        this.props.client.query({
                                            query: usuarioAutoCompleteQuery,
                                            variables: {
                                                nome: query,
                                            },
                                            fetchPolicy: "network-only"
                                        }).then(json => {
                                            json.data.usuarioAutoComplete.forEach( el => {
                                                const login = el.email.split('@')[0];
                                                let sufixo = "";
                                                if(el.identificador.indexOf('LOCAL::') != 0) {
                                                    sufixo = ' ( '+login+' )';
                                                }
                                                el['display_name'] = el.nome + sufixo;
                                            });

                                            this.setState({
                                                isLoadingUser: false,
                                                options: json.data.usuarioAutoComplete
                                            });
                                        });
                                    }}
                                    onChange = {(selectedItem) => {
                                        const usuario = selectedItem.shift()
                                        this.setState({
                                            usuarioSelecionado: usuario,
                                            queryString: usuario.nome,
                                        });
                                    }}
                                    options={this.state.options}
                                    flip
                                    ref={ref => this._convidadosAsyncTypeahead = ref}
                                />
                            </Col>
                            <Col xs="12" lg="5">
                                <Button
                                    disabled = {!this.state.usuarioSelecionado}
                                    className={classes.buttonAddConvidado}
                                    onClick = {() => {
                                        if (this.state.usuarioSelecionado.nome != this.state.queryString) return;
                                        if (values.convidados.filter( c => c.usuario != null).filter(c => c.usuario.id + "_" + c.papel.id === this.state.usuarioSelecionado.id + "_" + enums.papelList[0].id).length) return;

                                        setFieldValue('convidados', this.deduplicaConvidados([
                                            ...values.convidados,
                                            {
                                                usuario: {
                                                    ...this.state.usuarioSelecionado
                                                },
                                                grupo: null,
                                                papel: enums.papelList[1],
                                            },
                                        ]));

                                        this._convidadosAsyncTypeahead._instance.clear();
                                        this._convidadosAsyncTypeahead._instance.focus();

                                        this.notifyChange();
                                    }}
                                >
                                    Adicionar Convidado
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Fragment>
        );
    }

    renderSessaoAvançada(formikProps) {

        const { exibirSessaoAvancado } = this.props;
        if (!exibirSessaoAvancado) {
            return;
        }

        const { values, setFieldValue, handleChange } = formikProps;
        const { enums } = this.state;
        const { classes } = this.props;

        const maximoParticipantes = values.maximo_participantes || 0;
        const acessoViaLinkMaximoParticipantes = values.acesso_via_link_maximo_visitantes || 0;
        const layoutParticipante = values.layout_participante ? values.layout_participante : enums.layoutParticipanteOptions[0];

        let participantePodeEnviarChat = null;
        if ( values.participante_pode_enviar_chat == undefined ) {
            participantePodeEnviarChat = true;
        } else {
            participantePodeEnviarChat = values.participante_pode_enviar_chat;
        }

        return (
            <Row className={classes.grupoAccordion}>
                <Col md="12">
                    <Accordion defaultActiveKey={values.maximo_participantes || values.convidados.filter(c => c.grupo).length ? "0" : undefined}>
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="0" className={classes.accordionButton}>
                                    Avançado
                                </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse  eventKey="0">
                                <Card.Body>
                                    <Row className={classes.layoutParticipanteRow}>
                                        <Col md="3">
                                            Formato (Layout) para participantes
                                        </Col>
                                        <Col md="7">
                                            <Select
                                                className = {"gn-select"}
                                                placeholder = {"Selecione"}
                                                options = {enums.layoutParticipanteOptions}
                                                defaultValue = {layoutParticipante}
                                                getOptionValue = { el => el.id }
                                                getOptionLabel = { el => el.nome }
                                                onChange = { selectedItem => {
                                                    setFieldValue('layout_participante_id', selectedItem.id);
                                                    this.notifyChange()
                                                }}
                                                styles = {selectStyle}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={classes.participantePodeEnviarChatRow}>
                                        <Col md="3" className={classes.participantePodeEnviarChatLabel}>
                                            Participante pode enviar chat
                                        </Col>
                                        <Col className={classes.participantePodeEnviarChatCheckbox}>
                                            <Checkbox
                                                id="participante_pode_enviar_chat"
                                                onChange={handleChange}
                                                checked={participantePodeEnviarChat}
                                                value={values.participante_pode_enviar_chat}
                                                className={classes.checkBoxLike}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={classes.rowMaxParticipantes}>
                                        <Col>
                                            <Label htmlFor={"maximo_participantes"}>Max de participantes</Label>
                                        </Col>
                                    </Row>
                                    <Row className={classes.rowMaxParticipantes}>
                                        <Col xs="12" sm="3" md={{span: 2, offset: 1}}>
                                            <Label htmlFor={"maximo_participantes"}>Convidados</Label><br/>
                                        </Col>
                                        <Col xs="12" sm={9} md="2">
                                            <Control id="maximo_participantes" onChange={handleChange} type="number" value={maximoParticipantes} className={classes.qtdParticipantes}></Control>
                                        </Col>
                                    </Row>
                                    {
                                        values.permite_acesso_via_link == true ?
                                            <Fragment>
                                            <Row className={classes.rowMaxParticipantes}>
                                                <Col xs="12" sm="3" md={{span: 2, offset: 1}}>
                                                    <Label htmlFor={"acesso_via_link_maximo_visitantes"}>Visitantes</Label>
                                                </Col>
                                                <Col xs="12" sm={9} md="2">
                                                    <Control id="acesso_via_link_maximo_visitantes" onChange={handleChange} type="number" value={acessoViaLinkMaximoParticipantes} className={classes.qtdParticipantes}></Control>
                                                </Col>
                                            </Row>
                                            <Row className={classes.rowAcessoViaLinkCampos}>
                                                <Col md="3"><Label style={{paddingTop: '9px'}}>Solicitar os seguintes campos no acesso via link:</Label></Col>
                                                <Col md="2">
                                                    <Checkbox
                                                        id="acesso_via_link_requer_email"
                                                        onChange={handleChange}
                                                        checked={values.acesso_via_link_requer_email || false}
                                                        value={values.acesso_via_link_requer_email}
                                                        className={classes.checkBoxLike}
                                                        disabled={!values.permite_acesso_via_link}
                                                    />
                                                    <Label htmlFor="acesso_via_link_requer_email" className={classes.checkboxLabel}>
                                                        E-mail
                                                    </Label>
                                                </Col>

                                                <Col md="2">
                                                    <Checkbox
                                                        id="acesso_via_link_requer_instituicao"
                                                        onChange={handleChange}
                                                        checked={values.acesso_via_link_requer_instituicao || false}
                                                        value={values.acesso_via_link_requer_instituicao}
                                                        className={classes.checkBoxLike}
                                                        disabled={!values.permite_acesso_via_link}
                                                    />
                                                    <Label htmlFor="acesso_via_link_requer_instituicao" className={classes.checkboxLabel}>
                                                        Instituição
                                                    </Label>
                                                </Col>

                                                <Col md="2">
                                                    <Checkbox
                                                        id="acesso_via_link_requer_cargo"
                                                        onChange={handleChange}
                                                        checked={values.acesso_via_link_requer_cargo || false}
                                                        value={values.acesso_via_link_requer_cargo}
                                                        className={classes.checkBoxLike}
                                                        disabled={!values.permite_acesso_via_link}
                                                    />
                                                    <Label htmlFor="acesso_via_link_requer_cargo" className={classes.checkboxLabel}>
                                                        Cargo
                                                    </Label>
                                                </Col>
                                            </Row>
                                    </Fragment>: null
                                    }

                                    <Row>
                                        <Col md="3">
                                            <Label>Grupos: </Label>
                                        </Col>
                                        <Col md={{span: 9}}>
                                            {values.convidados.filter( c => c.grupo != null ).map((i) => {                                          
                                                return (
                                                    <Fragment key={i.grupo.id + ' +' + i.grupo.nome}>
                                                        <Row>
                                                            <Col xs="2" lg="1" className={classes.grupoRow}>
                                                                {(<IconButton
                                                                    onClick={() => {
                                                                        setFieldValue('convidados', 
                                                                            this.deduplicaConvidados(values.convidados.filter(u => u.usuario || u.grupo.id !== i.grupo.id))
                                                                        );
                                                                        this._grupoAsyncTypeahead._instance.focus();
                                                                        this.notifyChange();
                                                                    }}
                                                                >
                                                                    <HighlightOffOutlinedIcon />
                                                                </IconButton>)}
                                                            </Col>

                                                            <Col xs="9" lg="6" className={classes.gruposList}>
                                                                <Label>{i.grupo.nome}</Label>
                                                            </Col>

                                                            <Col sm="12" lg="5">
                                                                <Select
                                                                    className = {"gn-select"}
                                                                    placeholder = {"Execução"}
                                                                    options = {enums.papelList}
                                                                    defaultValue = {i.papel}
                                                                    getOptionValue = {el => {
                                                                        return el.id
                                                                    }}
                                                                    getOptionLabel={el => el.nome}
                                                                    onChange = { selectedItem => {
                                                                        setFieldValue('convidados', this.deduplicaConvidados( [
                                                                            ...values.convidados.filter(u => u.usuario || u.grupo.id !== i.grupo.id),
                                                                            {
                                                                                usuario: null,
                                                                                grupo: {
                                                                                    ...i.grupo,
                                                                                },
                                                                                papel: selectedItem,
                                                                                Fragment
                                                                            },
                                                                        ]));
                                                                        this.notifyChange();
                                                                    }}
                                                                    styles = {selectStyle}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Fragment>
                                                );
                                            })}
                                        </Col>
                                    </Row>

                                    <Row >
                                        <Col sm={{span: 9, offset: 3}}>
                                            <Row className={classes.addGrupoRow}>
                                                <Col xs="12" lg={{span: 6, offset: 1}}>
                                                    <AsyncTypeahead
                                                        id = {'search-convidados'}
                                                        isLoading = {this.state.isLoadingUser}
                                                        labelKey = "nome"
                                                        onSearch = { query => {
                                                            this.setState({
                                                                queryStringGrupo: query
                                                            });
                                                            if (query.length < 4) return;
                                                            this.setState({ isLoadingUser: true });
                                                            this.props.client.query({
                                                                query: grupoAutoCompleteQuery,
                                                                variables: {
                                                                    nome: query,
                                                                },
                                                                fetchPolicy: "network-only"
                                                            }).then(json => {
                                                                this.setState({
                                                                    isLoadingUser: false,
                                                                    optionsGrupo: json.data.grupoAutoComplete
                                                                });
                                                            });
                                                        } }
                                                        onChange = { selectedItem => {
                                                            const grupo = selectedItem.shift();
                                                            this.setState({
                                                                grupoSelecionado: grupo,
                                                                queryStringGrupo: grupo.nome,
                                                            });
                                                        } }
                                                        options = {this.state.optionsGrupo}
                                                        flip
                                                        ref={ref => this._grupoAsyncTypeahead = ref}
                                                    />
                                                </Col>
                                                <Col xs="12" lg="5">
                                                    <Button
                                                        className={classes.buttonAddGrupo}
                                                        disabled={!this.state.grupoSelecionado}
                                                        onClick={() => {
                                                            if (this.state.grupoSelecionado.nome != this.state.queryStringGrupo) return;
                                                            if (values.convidados.filter( c => c.grupo != null).filter(c => c.grupo.id === this.state.grupoSelecionado.id).length) return;
                                                            setFieldValue('convidados', this.deduplicaConvidados( [
                                                                ...values.convidados,
                                                                {
                                                                    grupo: {
                                                                        ...this.state.grupoSelecionado,
                                                                    },
                                                                    papel: enums.papelList[1],
                                                                },
                                                            ]));

                                                            this._grupoAsyncTypeahead._instance.clear();
                                                            this._grupoAsyncTypeahead._instance.focus();

                                                            this.notifyChange();
                                                        }}
                                                    >
                                                        Adicionar Grupo
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </Col>
            </Row>
        );
    }

    handleFormikSubmit(data) {
        const submitData = { ...data };

        const raiseError = message => {
            Swal.fire({
                title: "Verifique os dados informados",
                text: message,
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
            return;
        };

        if ( ( this.state.inicio_time && this.state.inicio_time == 'Invalid Date' )
            || ( this.state.fim_time && this.state.fim_time == 'Invalid Date' ) ) {
            return raiseError('Verifique as datas definidas');
        }

        if (!submitData.inicio || !submitData.fim) {
            return raiseError('Preencha as datas da sessão');
        }

        if (submitData.inicio > submitData.fim) {
            return raiseError('Data de início posterior a data de fim');
        }

        const durationHours = moment.duration(moment(submitData.fim).diff(moment(submitData.inicio))).asHours();

        if (durationHours > 24) {
            return raiseError('Duração máxima de uma sala é de 24 horas');
        }

        if (durationHours < 0.5) {
            return raiseError('Duração mínima de uma sala é de 30 minutos');
        }

        if (!submitData.nome) {
            return raiseError('Preencha o nome da sessão');
        }

        if (!submitData.texto_convite) {
            return raiseError('Preencha o texto do convite da sessão');
        }

        // const apenasConvidados = submitData.convidados.filter( el => !el.grupo );
        // const convidadosSemPapel = apenasConvidados.filter( convidado => convidado.papel.id == 0 );

        // if (convidadosSemPapel.length > 0) {
        //     return raiseError('Existem convidados sem papel definido');
        // }

        // const apenasGrupos  = submitData.convidados.filter( el => el.grupo );
        // const gruposSemPapel = apenasGrupos.filter( grupo => grupo.papel.id == 0 );

        // if (gruposSemPapel.length > 0) {
        //     return raiseError('Existem grupos sem papel definido');
        // }

        submitData.inicio = data.inicio.toISOString();
        submitData.fim = data.fim.toISOString();

        let layoutParticipanteId = null;

        if (submitData.layout_participante_id) {
            layoutParticipanteId = submitData.layout_participante_id;
        } else {
            if (submitData.layout_participante) {
                layoutParticipanteId = submitData.layout_participante.id;
            }
        }

        submitData['layout_participante_id'] = layoutParticipanteId;
        delete submitData.layout_participante;

        this.props.client.mutate({
            mutation: novaSessaoSave,
            variables: { input: Mutation.cleanupData(submitData) },
        }).then((data) => {
            let texto_convite = submitData.texto_convite;

            texto_convite = texto_convite.replace("{{LINK}}", window.location.protocol + "//" + window.location.host+PUBLIC_URL+'/'+data.data.novaSessaoSave.slug);

            let alerta_gravacao = "";

            if(submitData.gravar && this.props.branding.recording_durability_warning)
                alerta_gravacao = "<p style=\"color: red\">" + this.props.branding.recording_durability_warning + "</p>";

            Swal.fire({
                title: "Sessão salva!",
                html: alerta_gravacao +
                    "<div style='text-align: left; font-size: 12px; font-weight: bold;'>Convite:</div></div><div style='border: 1px solid #c0c0c0; padding: 20px; max-height: 300px; overflow: scroll;'>" +
                    texto_convite +
                    "</div>", //data.slug,
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            }).then( el => {
                const { handleModalClose, history } = this.props;
                if (handleModalClose) {
                    handleModalClose();
                }
                history.push('/org-agendadas');
            });
        }).catch((ex) => {
            const errorMessage = ex.graphQLErrors.map ( e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao Salvar nova sessão",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        })
    }

}

SessaoForm.propTypes = propTypes;
SessaoForm.defaultProps = defaultProps;


export default withRouter(withApollo(connect((state) => {
  return {
    userId: state.auth.user.id,
    branding: state.branding
  };
})(withStyles(styles)(SessaoForm))));